<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><a id="ch00_fm04_copy"></a><a id="page_6"></a>First published in 2010 by<br/>Red Wheel/Weiser, LLC<br/>With offices at:<br/>500 Third Street, Suite 230<br/>San Francisco, CA 94107<br/><em><span class="weblink"><a class="nounder" href="http://www.redwheelweiser.com" target="_blank">www.redwheelweiser.com</a></span></em></p>
<p class="copyright">Copyright © 2010 by Addie Johnson.<br/>All rights reserved. No part of this publication may be<br/>reproduced or transmitted in any form or by any means,<br/>electronic or mechanical, including photocopying, recording,<br/>or by any information storage and retrieval system, without<br/>permission in writing from Red Wheel/Weiser, LLC.<br/>Reviewers may quote brief passages.</p>
<p class="copyright">ISBN: 978-1-57324-474-9<br/>Library of Congress Cataloging-in-Publication Data<br/>is available upon request.</p>
<p class="copyright">Cover and text design by Jessica Dacher<br/>Proofread by Erin Brenner<br/>Typeset in Trade Gothic, Triplex, and French Iconic</p>
<p class="copyright">Printed in Hong Kong<br/>GW<br/>10  9  8  7  6  5  4  3  2  1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm04_copy.vue?94831c1c